import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteSettingsContext = createContext({ settings: null, loading: true, refresh: () => {} });

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/site/settings`);
      setSettings(data);
    } catch (e) {
      setSettings(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Listen for admin-triggered updates in the same tab
  useEffect(() => {
    const handler = () => load();
    window.addEventListener('gmre:settings-updated', handler);
    return () => window.removeEventListener('gmre:settings-updated', handler);
  }, [load]);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refresh: load }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}

/**
 * pick(value, fallback) — return trimmed value if truthy, else fallback.
 * Useful for CMS overrides where empty string means "use default".
 */
export const pick = (value, fallback) => {
  if (value == null) return fallback;
  const s = typeof value === 'string' ? value.trim() : value;
  return s === '' ? fallback : s;
};
